import MemberInfoFormContainer from './MemberInfoFormContainer';

export default MemberInfoFormContainer;
